/** True si el término de búsqueda es solo dígitos (búsqueda por nro. comprobante). */
export function esBusquedaNroComprobante(term: string): boolean {
  return /^\d+$/.test(term.trim());
}

/**
 * Coincide si el nro. de comprobante contiene el término (ej. "137" → 13735 / 00013735).
 */
export function coincideNroComprobante(
  nroComprobante: number | string | null | undefined,
  termino: string
): boolean {
  const t = termino.trim();
  if (!t) return true;
  const raw = String(nroComprobante ?? '').trim();
  if (!raw) return false;
  const digits = raw.replace(/\D/g, '');
  if (!digits) return false;
  const sinCeros = digits.replace(/^0+/, '') || '0';
  const padded = digits.padStart(8, '0');
  return digits.includes(t) || sinCeros.includes(t) || padded.includes(t);
}
